import React from "react";
import { HistoryItemDate } from "./styledComponents";

export type AuditEditLabelProps = {
  label: string;
  date: string;
  author?: string;
};

/**
 * Shared component for displaying edit label with date and optional author in parentheses.
 * Used in both section subtitles and history items for consistency.
 * Format: Label (author date) or Label (date) if no author
 */
export const AuditEditLabel = ({ label, date, author }: AuditEditLabelProps) => {
  const displayText = author ? `${author}${date}` : date;

  return (
    <>
      {label}
      <HistoryItemDate>({displayText})</HistoryItemDate>
    </>
  );
};
